import { render } from "./page-default.vue?vue&type=template&id=c82840e2"
import script from "./page-default.vue?vue&type=script&lang=js"
export * from "./page-default.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__